import {
  Companion_getInstance12ven2xbljkm0 as Companion_getInstance,
  ContractorNote59o6kpmrrw5h as ContractorNote,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_message(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorNote_message_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorNote_project_getInstance());
}
function get_at(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorNote_at_getInstance());
}
function prepareContractorNoteFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ContractorNote__id_getInstance(), ContractorNote_project_getInstance(), ContractorNote_lineItem_getInstance(), ContractorNote_message_getInstance(), ContractorNote_files_getInstance(), ContractorNote_at_getInstance(), ContractorNote_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ContractorNote_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ContractorNote_message$_get_name_$ref_qrwtcs() {
  return (p0) => p0.k20();
}
function ContractorNote_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_message$_get_serializer_$ref_nyrr2b() {
  return (p0) => p0.j2j();
}
function ContractorNote_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ContractorNote_message$_get_annotations_$ref_man887() {
  return (p0) => p0.bz();
}
var ContractorNote_messageClass;
function ContractorNote_message() {
  if (ContractorNote_messageClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_message_instance = this;
        var tmp = this;
        tmp.z5o_1 = lazy(ContractorNote_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a5p_1 = lazy(ContractorNote_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b5p_1 = lazy(ContractorNote_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_message$_get_name_$ref_qrwtcs(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.g5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      k5p(receiver, value) {
        return receiver.l5p(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.k5p(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_message$_get_serializer_$ref_nyrr2b(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_message$_get_annotations_$ref_man887(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_message', VOID, VOID, [SerializableProperty()]);
    ContractorNote_messageClass = $;
  }
  return ContractorNote_messageClass;
}
var ContractorNote_message_instance;
function ContractorNote_message_getInstance() {
  if (ContractorNote_message_instance === VOID)
    new (ContractorNote_message())();
  return ContractorNote_message_instance;
}
function ContractorNote_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ContractorNote_project$_get_name_$ref_18tv6a() {
  return (p0) => p0.k20();
}
function ContractorNote_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_project$_get_serializer_$ref_qyqe7f() {
  return (p0) => p0.j2j();
}
function ContractorNote_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ContractorNote_project$_get_annotations_$ref_wkbhtz() {
  return (p0) => p0.bz();
}
var ContractorNote_projectClass;
function ContractorNote_project() {
  if (ContractorNote_projectClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_project_instance = this;
        var tmp = this;
        tmp.m5p_1 = lazy(ContractorNote_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5p_1 = lazy(ContractorNote_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5p_1 = lazy(ContractorNote_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_project$_get_name_$ref_18tv6a(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.e5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      p5p(receiver, value) {
        return receiver.l5p(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.p5p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_project$_get_serializer_$ref_qyqe7f(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_project$_get_annotations_$ref_wkbhtz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_project', VOID, VOID, [SerializableProperty()]);
    ContractorNote_projectClass = $;
  }
  return ContractorNote_projectClass;
}
var ContractorNote_project_instance;
function ContractorNote_project_getInstance() {
  if (ContractorNote_project_instance === VOID)
    new (ContractorNote_project())();
  return ContractorNote_project_instance;
}
function ContractorNote_at$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ContractorNote_at$_get_name_$ref_8zy1zc() {
  return (p0) => p0.k20();
}
function ContractorNote_at$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_at$_get_serializer_$ref_5ayavz() {
  return (p0) => p0.j2j();
}
function ContractorNote_at$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ContractorNote_at$_get_annotations_$ref_wk3pvn() {
  return (p0) => p0.bz();
}
var ContractorNote_atClass;
function ContractorNote_at() {
  if (ContractorNote_atClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_at_instance = this;
        var tmp = this;
        tmp.q5p_1 = lazy(ContractorNote_at$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r5p_1 = lazy(ContractorNote_at$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s5p_1 = lazy(ContractorNote_at$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.t5p_1 = get_default(Companion_instance).d1m();
        this.u5p_1 = 'now()';
      }
      k20() {
        var tmp0 = this.q5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_at$_get_name_$ref_8zy1zc(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.i5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      v5p(receiver, value) {
        return receiver.l5p(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.v5p(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_at$_get_serializer_$ref_5ayavz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_at$_get_annotations_$ref_wk3pvn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_at', VOID, VOID, [SerializableProperty()]);
    ContractorNote_atClass = $;
  }
  return ContractorNote_atClass;
}
var ContractorNote_at_instance;
function ContractorNote_at_getInstance() {
  if (ContractorNote_at_instance === VOID)
    new (ContractorNote_at())();
  return ContractorNote_at_instance;
}
function ContractorNote__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ContractorNote__id$_get_name_$ref_f8mslt() {
  return (p0) => p0.k20();
}
function ContractorNote__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote__id$_get_serializer_$ref_jbrtzq() {
  return (p0) => p0.j2j();
}
function ContractorNote__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ContractorNote__id$_get_annotations_$ref_o1cli2() {
  return (p0) => p0.bz();
}
var ContractorNote__idClass;
function ContractorNote__id() {
  if (ContractorNote__idClass === VOID) {
    class $ {
      constructor() {
        ContractorNote__id_instance = this;
        var tmp = this;
        tmp.w5p_1 = lazy(ContractorNote__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x5p_1 = lazy(ContractorNote__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y5p_1 = lazy(ContractorNote__id$annotations$delegate$lambda);
        this.z5p_1 = Companion_getInstance_0().m2p();
        this.a5q_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.w5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote__id$_get_name_$ref_f8mslt(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.d5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      p5p(receiver, value) {
        return receiver.l5p(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.p5p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote__id$_get_serializer_$ref_jbrtzq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y5p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote__id$_get_annotations_$ref_o1cli2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote__id', VOID, VOID, [SerializableProperty()]);
    ContractorNote__idClass = $;
  }
  return ContractorNote__idClass;
}
var ContractorNote__id_instance;
function ContractorNote__id_getInstance() {
  if (ContractorNote__id_instance === VOID)
    new (ContractorNote__id())();
  return ContractorNote__id_instance;
}
function ContractorNote_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ContractorNote_lineItem$_get_name_$ref_9gssno() {
  return (p0) => p0.k20();
}
function ContractorNote_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_lineItem$_get_serializer_$ref_i3n7cd() {
  return (p0) => p0.j2j();
}
function ContractorNote_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ContractorNote_lineItem$_get_annotations_$ref_n7m6o9() {
  return (p0) => p0.bz();
}
var ContractorNote_lineItemClass;
function ContractorNote_lineItem() {
  if (ContractorNote_lineItemClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_lineItem_instance = this;
        var tmp = this;
        tmp.b5q_1 = lazy(ContractorNote_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5q_1 = lazy(ContractorNote_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5q_1 = lazy(ContractorNote_lineItem$annotations$delegate$lambda);
        this.e5q_1 = null;
        this.f5q_1 = 'null';
      }
      k20() {
        var tmp0 = this.b5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_lineItem$_get_name_$ref_9gssno(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.f5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      g5q(receiver, value) {
        return receiver.l5p(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.g5q(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_lineItem$_get_serializer_$ref_i3n7cd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_lineItem$_get_annotations_$ref_n7m6o9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_lineItem', VOID, VOID, [SerializableProperty()]);
    ContractorNote_lineItemClass = $;
  }
  return ContractorNote_lineItemClass;
}
var ContractorNote_lineItem_instance;
function ContractorNote_lineItem_getInstance() {
  if (ContractorNote_lineItem_instance === VOID)
    new (ContractorNote_lineItem())();
  return ContractorNote_lineItem_instance;
}
function ContractorNote_files$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ContractorNote_files$_get_name_$ref_vfov04() {
  return (p0) => p0.k20();
}
function ContractorNote_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_files$_get_serializer_$ref_cbg0d() {
  return (p0) => p0.j2j();
}
function ContractorNote_files$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ContractorNote_files$_get_annotations_$ref_5hua7d() {
  return (p0) => p0.bz();
}
var ContractorNote_filesClass;
function ContractorNote_files() {
  if (ContractorNote_filesClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_files_instance = this;
        var tmp = this;
        tmp.h5q_1 = lazy(ContractorNote_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5q_1 = lazy(ContractorNote_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5q_1 = lazy(ContractorNote_files$annotations$delegate$lambda);
        this.k5q_1 = emptyList();
        this.l5q_1 = 'emptyList()';
      }
      k20() {
        var tmp0 = this.h5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_files$_get_name_$ref_vfov04(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.h5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      m5q(receiver, value) {
        return receiver.l5p(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.m5q(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_files$_get_serializer_$ref_cbg0d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_files$_get_annotations_$ref_5hua7d(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_files', VOID, VOID, [SerializableProperty()]);
    ContractorNote_filesClass = $;
  }
  return ContractorNote_filesClass;
}
var ContractorNote_files_instance;
function ContractorNote_files_getInstance() {
  if (ContractorNote_files_instance === VOID)
    new (ContractorNote_files())();
  return ContractorNote_files_instance;
}
function ContractorNote_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ContractorNote_readBy$_get_name_$ref_v6r27i() {
  return (p0) => p0.k20();
}
function ContractorNote_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorNote_readBy$_get_serializer_$ref_civ6tj() {
  return (p0) => p0.j2j();
}
function ContractorNote_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ContractorNote_readBy$_get_annotations_$ref_gzlj19() {
  return (p0) => p0.bz();
}
var ContractorNote_readByClass;
function ContractorNote_readBy() {
  if (ContractorNote_readByClass === VOID) {
    class $ {
      constructor() {
        ContractorNote_readBy_instance = this;
        var tmp = this;
        tmp.n5q_1 = lazy(ContractorNote_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o5q_1 = lazy(ContractorNote_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p5q_1 = lazy(ContractorNote_readBy$annotations$delegate$lambda);
        this.q5q_1 = emptySet();
        this.r5q_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.n5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorNote_readBy$_get_name_$ref_v6r27i(), null);
        return tmp0.f2();
      }
      c5p(receiver) {
        return receiver.j5p_1;
      }
      m2j(receiver) {
        return this.c5p(receiver instanceof ContractorNote() ? receiver : THROW_CCE());
      }
      s5q(receiver, value) {
        return receiver.l5p(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorNote() ? receiver : THROW_CCE();
        return this.s5q(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorNote_readBy$_get_serializer_$ref_civ6tj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorNote_readBy$_get_annotations_$ref_gzlj19(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorNote_readBy', VOID, VOID, [SerializableProperty()]);
    ContractorNote_readByClass = $;
  }
  return ContractorNote_readByClass;
}
var ContractorNote_readBy_instance;
function ContractorNote_readBy_getInstance() {
  if (ContractorNote_readBy_instance === VOID)
    new (ContractorNote_readBy())();
  return ContractorNote_readBy_instance;
}
//region block: exports
export {
  get_at as get_at1y0kiqq3vi1b7,
  get_message as get_message3j75qq96irblw,
  prepareContractorNoteFields as prepareContractorNoteFieldsaea4hwoz1qax,
  get_project as get_project34plxwa7097z4,
};
//endregion

//# sourceMappingURL=ContractorNoteFields.mjs.map
